type RecipeUnavailableReason = 'expired' | 'phone_invalid'

type RecipeUnavailableScreenProps = {
  reason: RecipeUnavailableReason
}

const COPY: Record<RecipeUnavailableReason, { title: string; description: string }> = {
  // Decisão 17: token inválido/expirado -> tela de "link expirado" com
  // contato, não erro genérico.
  expired: {
    title: 'Este link não é mais válido',
    description: 'O link da sua receita expirou ou não existe. Fale com um atendente para receber um novo acesso.'
  },
  // Decisão 14: paciente sem celular válido (não normalizável para E.164) ->
  // não libera a receita, oferece "Fale com atendente". Melhor trancar do
  // que abrir dado clínico sem prova.
  phone_invalid: {
    title: 'Não conseguimos confirmar seu acesso',
    description: 'Não foi possível validar seu celular cadastrado. Fale com um atendente para acessar sua receita.'
  }
}

// Cobre as decisões 14 e 17 da nota [CC][F-receita-codigo-acesso] — ambas são
// estados sem saída própria no fluxo, só contato com atendimento.
export const RecipeUnavailableScreen = ({ reason }: RecipeUnavailableScreenProps) => {
  const copy = COPY[reason]

  return (
    <div className="flex w-full max-w-[420px] flex-col items-center gap-4 self-center rounded-2xl border border-gray-100 bg-white px-6 py-8 text-center shadow-sm">
      <h1 className="text-lg font-semibold text-gray-950">{copy.title}</h1>
      <p className="text-sm text-gray-500">{copy.description}</p>
      <a
        href="https://whts.co/Cannect"
        className="w-full rounded-lg bg-primary-600 px-4 py-3 text-sm font-semibold text-white hover:bg-primary-700">
        Fale com um atendente
      </a>
    </div>
  )
}
